import Style from './style'

import Pagenation from 'widget/Pagenation'

import useGetMyStoreStoreSticketRecord from 'entity/store/useGetMyStoreTicketRecord'

import {convertRecordTypeAsNameForStore} from 'shared/constant/lookup/recordType'
import timestampCalculator from 'shared/lib/timestampCalculator'
import TStyle from 'shared/style/tableStyle'
import SortableHeader from 'shared/ui/SortableHeader'
import TableLoading from 'shared/ui/TableLoading'
import Search from 'widget/Search'
import useRoleCookie from 'shared/model/useRoleCookie'
import {ROLE_FRANCHISE_MANAGER} from 'shared/constant/lookup/role'

const MyStoreTicketRecord = () => {
	const prefix = 'ticketRecord'
	const [myTicketRecord, isLoading] = useGetMyStoreStoreSticketRecord(prefix)

	const [roleCookie] = useRoleCookie()

	const isFranchiseManager = roleCookie === ROLE_FRANCHISE_MANAGER

	const recordSizeList = [
		'short',
		'medium',
		'long',
		'long',
		'long',
		'long',
		'long',
		'expand',
		'medium',
		'short',
		'long',
	]
	const recordTableHeadList = [
		{label: 'IDX', sortKey: 'idx'},
		{label: '사용자 IDX', sortKey: 'account_idx'},
		{label: '이름', sortKey: 'account_name'},
		{label: '닉네임', sortKey: 'account_nickname'},
		{label: '연락처', sortKey: 'account_contact'},
		{label: '매장 이용권 유형', sortKey: 'ticket_type_name'},
		{label: '매장', sortKey: 'ticket_type_name'},
		{label: '사용처', sortKey: 'event_name'},
		{label: '분류', sortKey: 'ticket_record_type_flag'},
		{label: '개수', sortKey: 'number'},
		{label: '기록 날짜', sortKey: 'created_at'},
	]
	return (
		<Style.Wrapper>
			<Style.Area $expand>
				{!isFranchiseManager && <h2>매장 이용권 사용 기록</h2>}

				<Search
					placeholder='IDX, 이름 및 닉네임으로 검색 가능'
					voucherTypeFilter={true}
					prefix={prefix}
				/>

				<TableLoading isLoading={isLoading}>
					<TStyle.TableDiv>
						<TStyle.TableInner>
							<TStyle.TableRow $title>
								{recordTableHeadList.map((elem, index) => (
									<TStyle.Data key={index} $title $size={recordSizeList[index]}>
										<SortableHeader sortKey={elem.sortKey} prefix={prefix}>
											{elem.label}
										</SortableHeader>
									</TStyle.Data>
								))}
							</TStyle.TableRow>
							{myTicketRecord?.data?.store_ticket_record?.map((elem, index) => {
								return (
									<TStyle.TableRow key={index} $odd={index % 2 === 1}>
										<TStyle.Data $size={recordSizeList[0]}>
											{elem?.idx}
										</TStyle.Data>
										<TStyle.Data $size={recordSizeList[1]}>
											{elem?.account_idx}
										</TStyle.Data>
										<TStyle.Data $size={recordSizeList[2]}>
											{elem?.account_name}
										</TStyle.Data>
										<TStyle.Data $size={recordSizeList[3]}>
											{elem?.account_nickname}
										</TStyle.Data>
										<TStyle.Data $size={recordSizeList[4]}>
											{elem?.account_contact}
										</TStyle.Data>
										<TStyle.Data $size={recordSizeList[5]}>
											{elem?.ticket_type_name}
										</TStyle.Data>
										<TStyle.Data $size={recordSizeList[6]}>
											{elem?.store_name}
										</TStyle.Data>
										<TStyle.Data $size={recordSizeList[7]}>
											{elem?.event_name || '-'}
										</TStyle.Data>
										<TStyle.Data $size={recordSizeList[8]}>
											{convertRecordTypeAsNameForStore[elem?.ticket_record_type_flag]}
										</TStyle.Data>
										<TStyle.Data $size={recordSizeList[9]}>
											{elem?.ticket_number}
										</TStyle.Data>
										<TStyle.Data $size={recordSizeList[10]}>
											{timestampCalculator(elem?.created_at)}
										</TStyle.Data>
									</TStyle.TableRow>
								)
							})}
						</TStyle.TableInner>
					</TStyle.TableDiv>
				</TableLoading>

				<Pagenation maxPage={myTicketRecord?.data?.max_page} prefix={prefix} />
			</Style.Area>
		</Style.Wrapper>
	)
}

export default MyStoreTicketRecord
